/**
 * Removes any ngStorage- prefixes from local storage keys
 */
export default function migrateOldKeys() {
  if (!window.localStorage) {
    return
  }
  const keys = Object.keys(window.localStorage)

  for (const key of keys) {
    if (key.startsWith('ngStorage-')) {
      const newKey = key.replace('ngStorage-', '')
      localStorage.setItem(newKey, localStorage.getItem(key))
      localStorage.removeItem(key)
    }
  }
}
